<template>
    <HighChart
        :options="chartOptions"
    />
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue';
import HighChart from '@agyletime/vue-3-common/src/components/Chart/HighChart.vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';

import { SeriesData } from '../interactionSummary/getData';

exportingInit(Highcharts);

interface IProps {
  categories: string[];
  series: SeriesData[];
}
const props = defineProps<IProps>();
const chartOptions = computed(() => ({
    credits: { enabled: false },
    chart: { type: 'area' },
    title: {
        text: 'Total Workload Effort by Time',
        align: 'left',
        style: {
            fontSize: '21px',
            fontWeight: 'bold',
            fontFamily: 'Realist'
        },
        margin: 24
    },
    yAxis: {
        title: {
            useHTML: true,
            text: 'Time (in seconds)',
            margin: 16
        }
    },
    xAxis: { categories: props.categories },
    tooltip: {
        shared: true,
        headerFormat: '<span style="font-size:12px"><b>{point.key}</b></span><br>'
    },
    plotOptions: {
        area: {
            stacking: 'normal',
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
                lineWidth: 1,
                lineColor: '#666666'
            }
        }
    },
    series: props.series
}));
</script>

<style scoped lang="scss" src="./style.scss"></style>
